import type { ComponentType } from "react";
import { blockMap } from "@landrr/blocks";
import { QuickStart } from "../blocks/QuickStart";

type PageEntry = string | { block: string; [key: string]: unknown };

const siteBlockMap: Record<string, ComponentType<Record<string, unknown>>> = {
  ...blockMap,
  quickStart: QuickStart as ComponentType<Record<string, unknown>>,
};

interface BlockRendererProps {
  entries: readonly PageEntry[];
}

export function BlockRenderer({ entries }: BlockRendererProps) {
  return (
    <>
      {entries.map((entry, i) => {
        const blockId = typeof entry === "string" ? entry : entry.block;
        const props =
          typeof entry === "string" ? {} : { ...entry, block: undefined };
        const Block = siteBlockMap[blockId];
        if (!Block) return null;
        return <Block key={i} {...props} />;
      })}
    </>
  );
}
